import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";


const AllowedAccess = ({
  notAllow = false,
  userTypes,
  roles,
  renderAuthFailed,
  isLoading,
  children
}) => {
  const user = useSelector(selectCurrentUser);
  const [allowedAccess, setAllowedAccess] = useState(false)
  const [checking, setChecking] = useState(false)

  useEffect(() => {
    if (!user) {
      return;
    }
    setChecking(true)

    if (userTypes && user.userTypeId) {
      const intersection = userTypes.some(type => type === user.userTypeId)
      setAllowedAccess(notAllow ? !intersection : intersection);
    }

    if (roles && user.role) {
      const intersection = roles.some(role => role === user.role)
      setAllowedAccess(notAllow ? !intersection : intersection);
    }

    setChecking(false)
  }, [roles, userTypes, user, notAllow])

  if (!allowedAccess && checking) {
    return isLoading
  }

  if (allowedAccess) {
    return (
      children
    )
  }

  if (renderAuthFailed) {
    return renderAuthFailed
  }

  return null
}

export default AllowedAccess;